import api from './axios'

/**
 * Upload API
 * Handles file uploads for logos and other assets
 */
export const uploadApi = {
    /**
     * Upload a file
     * @param {File} file - The file to upload
     * @returns {Promise} - Response with URL
     */
    upload: async (file) => {
        const formData = new FormData()
        formData.append('file', file)

        const response = await api.post('/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response
    },

    /**
     * Delete an uploaded file
     * @param {string} filename - The filename to delete
     */
    delete: async (filename) => {
        const response = await api.delete('/upload', {
            data: { filename }
        })
        return response
    }
}

export default uploadApi
